import { SourcingStageStat } from 'api-clients/monolith';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import { StageMappingsForm } from './form';

interface EditStageMappingsProps {
  funnelData: SourcingStageStat[];
  hiringGoalConversionRate: number | null;
  refetchFunnelData?: () => Promise<void>;
  children: React.ReactNode;
}

export function EditStageMappings({
  funnelData,
  hiringGoalConversionRate,
  refetchFunnelData,
  children,
}: EditStageMappingsProps) {
  const [isSaving, setIsSaving] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);

  const showSpinner = (isSaving: boolean) => {
    setIsSaving(isSaving);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={() => setIsModalOpen(!isModalOpen)}
    >
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent className="min-w-[720px]">
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage
              defaultMessage="Map stages"
              description="Modal title: link ATS stages to sourcing funnel steps"
            />
          </DialogTitle>
        </DialogHeader>

        <StageMappingsForm
          funnelData={funnelData}
          showSpinner={showSpinner}
          refetchFunnelData={refetchFunnelData}
          hiringGoalConversionRate={hiringGoalConversionRate}
          setIsModalOpen={setIsModalOpen}
          setIsFormDirty={setIsFormDirty}
        >
          <DialogFooter>
            <Button type="submit" disabled={isSaving || !isFormDirty}>
              {isSaving && <Loader2 className="animate-spin" />}
              <FormattedMessage
                defaultMessage="Map stages"
                description="Submit: save funnel-to-workflow mappings from the modal"
              />
            </Button>
          </DialogFooter>
        </StageMappingsForm>
      </DialogContent>
    </Dialog>
  );
}
